<template>
  <b-dropdown class="border rounded bg-white" ref="dropdown" variant="grey" @hide="handleHide($event)"
    @hidden="isCloseable = false">
    <template #button-content>
      <i class="fa fa-filter"></i><span class="caret"></span>
    </template>
    <b-dropdown-form style="width: 30rem">
      <div class="row form theme-form">
        <div class="col-6">
          <b-tabs v-model="filterTab" content-class="mt-3" no-nav-style>
            <b-tab v-for="(item, j) in filter" :key="item + j" :title-link-class="linkClass(filterTab, j)" :title="item"
              :active="j == 0">
            </b-tab>
          </b-tabs>
        </div>

        <div class="col-6 text-right">
          <!-- <b-button
            v-if="filter.length == 1"
            class="saveFilter px-1 mx-1"
            @click="saveFilter"
            variant="tranperate"
          >
            <i class="icofont icofont-save"></i> Save Filter
          </b-button>
          <b-button
            v-else
            class="removeFilter px-1 mx-1"
            @click="removeFilter"
            variant="tranperate"
          >
            <i class="icofont icofont-trash"></i> Remove Filter
          </b-button> -->
          <b-button variant="primary" class="m-1" @click="filterd">
            Filter
          </b-button>
          <b-button class="px-2 mx-2" variant="tranperate" @click="closeMe()">
            <i class="icon-close"></i>
          </b-button>
        </div>

        <component ref="filter" :filterTab="filterTab" :is="custom" :col="col" :field="field" :module="module" />
      </div>
    </b-dropdown-form>
  </b-dropdown>
</template>

<script>
import filterCustomCase from './filter-custom/filter-custom-case.vue';
import filterCustomSms from './filter-custom/filter-custom-sms.vue';
import filterCustomMember from './filter-custom/filter-member.vue';
import filterCustomRule from './filter-custom/filter-rule.vue';
import filterReportDynamicVue from './filter-custom/report/filter-report-dynamic.vue';
import dynamicFilterVue from './filter-custom/dynamic-filter.vue';
import filterCustomHistory from './filter-custom/filter-custom-history.vue';
import filterCustomTemplate from './filter-custom/filter-custom-template.vue';
import filterQueueReport from './filter-custom/filter-queue-report.vue';

export default {
  components: {
    filterCustomHistory,
    filterCustomCase,
    filterCustomSms,
    filterCustomMember,
    filterCustomRule,
    filterReportDynamicVue,
    dynamicFilterVue,
    filterCustomTemplate,
    filterQueueReport
  },
  props: {
    custom: String,
    field: Array,
    module: String,
    col: Array,
  },

  data() {
    return {
      filterTab: 0,
      filter: ['Filter'],
      isCloseable: false,
    };
  },
  mounted() {
    // if (localStorage.getItem('filter')) {
    //   this.filter.push('My Filter');
    // }
  },

  methods: {
    handleHide(bvEvent) {
      if (!this.isCloseable) {
        bvEvent.preventDefault();
      } else {
        this.$refs.dropdown.hide();
      }
    },

    closeMe() {
      this.$refs.dropdown.hide();

      this.isCloseable = true;
    },
    linkClass(id, idx) {
      if (id == idx) {
        return [
          'border-bottom',
          'border-top-0',
          'border-left-0',
          'border-right-0',
          'bg-none',
          'border-primary',
          'text-primary',
        ];
      } else {
        return ['text-dark', 'border-bottom'];
      }
    },
    filterd() {
      this.$emit('update', this.$refs.filter.getFilter());
    },
    getFilter() {
      return this.$refs.filter.getFilter();
    },
    saveFilter() {
      this.filter.push('My Filter');
      localStorage.setItem(
        'filter',
        JSON.stringify(this.$refs.filter.getFilter())
      );
      setTimeout(() => {
        this.filterTab = 1;
      }, 10);
    },
    removeFilter() {
      localStorage.removeItem('filter');
      this.filter.pop();
    },
  },
};
</script>

<style>
.saveFilter {
  color: #006fff !important;
}

.saveFilter:hover {
  color: #0c59cc !important;
}

.removeFilter {
  color: #de3e4d !important;
}

.removeFilter:hover {
  color: #79141e !important;
}

.left {
  left: -6rem !important;
}
</style>
